import React from "react";
import TimeAgo from "react-timeago";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";

const RiskMatrixList = ({ items = [], onView }) => {
    if (items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong style={{ fontSize: "1.2em" }}>No Risk Matrix has been recorded this patient</strong>
            </div>
        );
    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th className="text-center">SN</th>
                    <th>Comment</th>
                    <th>Staff</th>
                    <th>Date Created</th>
                    <th className="text-center">View</th>
                </tr>
            </thead>
            <tbody>
                {items.map((item, index) => (
                    <tr key={index}>
                        <td className="inbox-small-cells text-center">{index + 1}</td>
                        <td className="view-message">
                            <span>{item.comment}</span>
                        </td>

                        <td className="view-message">
                            <StaffProfileCard item={item.author} />
                        </td>
                        <td className="view-message">
                            {cleanDate(item.created_at)}
                            <br />
                            <small className="text-muted">
                                <TimeAgo date={item.created_at}></TimeAgo>
                            </small>
                        </td>
                        <td className="text-center">
                            <button onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                <i className="material-icons text-primary">arrow_right_alt</i>
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default RiskMatrixList;
